import React, { useState, useEffect, useContext } from 'react';
import { MessageSquare, User, Wrench, Filter, Search, Calendar, ChevronDown } from 'lucide-react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/screens/admin/dashboard/systemfeedback/AdminFeedback.css';

const FILTERS = ['All', 'seeker', 'responder'];


const AdminFeedback = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [activeFilter, setActiveFilter] = useState('All');
  const [search, setSearch] = useState('');
  const [feedbacks, setFeedbacks] = useState([]);

  useEffect(() => {
    axios.get(`${baseUrl}/system/feedback`, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
      .then(res => {
        console.log('FEEDBACK API RESPONSE:', res.data.data);
        setFeedbacks(res.data.data || []);
      })
      .catch(err => {
        console.log('Error fetching feedbacks:', err);
      });
  }, [baseUrl, authToken]);
  const filtered = feedbacks.filter(f => {

    const type =
      f.whcustomer_id !== null
        ? 'seeker'
        : f.whserviceprovider_id !== null
          ? 'serviceprovider'
          : null;

    const matchFilter =
      activeFilter === 'All' ||
      type === activeFilter;

    const userName =
      f.whcustomer_id !== null
        ? f.customer?.fullName || ''
        : f.serviceprovider?.fullName || '';

    const matchSearch =
      userName.toLowerCase().includes(search.toLowerCase()) ||
      f.message.toLowerCase().includes(search.toLowerCase());

    return matchFilter && matchSearch;
  });

  const counts = {
    All: feedbacks.length,

    seeker: feedbacks.filter(
      f => f.whcustomer_id !== null
    ).length,

    responder: feedbacks.filter(
      f => f.whserviceprovider_id !== null
    ).length,
  };

  return (
    <div className="afb-page">

      {/* Header */}
      <div className="afb-header">
        <div className="afb-header-left">
          <div className="afb-header-icon">
            <MessageSquare size={22} />
          </div>
          <div>
            <h2 className="afb-title">System Feedback</h2>
            <p className="afb-subtitle">Reviews from seekers and responders</p>
          </div>
        </div>
        <div className="afb-total-badge">
          {feedbacks.length} Total
        </div>
      </div>

      {/* Search + Filters */}
      <div className="afb-controls">
        <div className="afb-search-wrap">
          <Search size={15} className="afb-search-icon" />
          <input
            type="text"
            className="afb-search"
            placeholder="Search by name or message..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <div className="afb-filters">
          {FILTERS.map(f => (
            <button
              key={f}
              className={`afb-filter-btn ${activeFilter === f ? 'afb-filter-btn--active' : ''}`}
              onClick={() => setActiveFilter(f)}
            >
              {f === 'Seeker' && <User size={13} />}
              {f === 'Responder' && <Wrench size={13} />}
              {f === 'All' && <Filter size={13} />}
              {f}
              <span className="afb-filter-count">{counts[f]}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Results count */}
      <p className="afb-results-label">
        Showing <strong>{filtered.length}</strong> {activeFilter === 'All' ? 'feedbacks' : `${activeFilter} feedbacks`}
      </p>

      {/* Cards Grid */}
      {filtered.length === 0 ? (
        <div className="afb-empty">
          <MessageSquare size={36} />
          <p>No feedback found.</p>
        </div>
      ) : (
        <div className="afb-grid">
          {filtered.map((fb, idx) => (
            <div
              className={`afb-card ${fb.whcustomer_id !== null
                ? 'afb-card--seeker'
                : 'afb-card--responder'
                }`}
            >

              {/* Card top */}
              <div className="afb-card-top">

                <div className="afb-avatar">
                  {(
                    fb.user_type === 'customer'
                      ? fb.customer?.fullName
                      : fb.serviceprovider?.fullName
                  )?.split(' ')
                    .map(word => word[0])
                    .join('')
                    .substring(0, 2)
                    .toUpperCase()}
                </div>

                <div className="afb-card-info">

                  <span className="afb-card-name">
                    {fb.whcustomer_id !== null
                      ? fb.customer?.fullName
                      : fb.serviceprovider?.fullName}
                  </span>

                  <div className="afb-card-meta">

                    <span
                      className={`afb-type-badge ${fb.user_type === 'customer'
                        ? 'afb-type-badge--seeker'
                        : 'afb-type-badge--responder'
                        }`}
                    >
                      {fb.user_type === 'customer'
                        ? <User size={10} />
                        : <Wrench size={10} />}

                      {fb.user_type === 'customer'
                        ? 'Seeker'
                        : 'Responder'}
                    </span>

                    <span className="afb-date">
                      <Calendar size={11} />

                      {new Date(fb.created_at).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </span>

                  </div>
                </div>
              </div>

              {/* Message */}
              <p className="afb-card-message">
                "{fb.message}"
              </p>

            </div>
          ))}
        </div>
      )}

    </div>
  );
};

export default AdminFeedback;